"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.brFormattedPhoneToPhone = exports.brPhoneToFormattedPhone = exports.peFormattedPhoneToPhone = exports.pePhoneToFormattedPhone = exports.clFormattedPhoneToPhone = exports.clPhoneToFormattedPhone = void 0;
var helpers_1 = require("./helpers");
var getStrWithPrefix = function (str, prefix) { return (str.indexOf(prefix) !== 0 ? "".concat(prefix).concat(str) : str); };
var clPhoneToFormattedPhone = function (str) {
    if (str.length < 3) {
        return str;
    }
    var stringToFormat = getStrWithPrefix(str, '+56');
    return (0, helpers_1.addCharToStr)(stringToFormat, ' ', 4);
};
exports.clPhoneToFormattedPhone = clPhoneToFormattedPhone;
var clFormattedPhoneToPhone = function (formatted) { return formatted.replace(/ /g, ''); };
exports.clFormattedPhoneToPhone = clFormattedPhoneToPhone;
var pePhoneToFormattedPhone = function (str) {
    if (str.length < 3) {
        return str;
    }
    var stringToFormat = getStrWithPrefix(str, '+51');
    return (0, helpers_1.addCharToStr)(stringToFormat, ' ', 4);
};
exports.pePhoneToFormattedPhone = pePhoneToFormattedPhone;
exports.peFormattedPhoneToPhone = exports.clFormattedPhoneToPhone;
var brPhoneToFormattedPhone = function (str) {
    if (str.length < 3) {
        return str;
    }
    var stringToFormat = getStrWithPrefix(str, '+55');
    return (0, helpers_1.addCharToStr)(stringToFormat, ' ', 4);
};
exports.brPhoneToFormattedPhone = brPhoneToFormattedPhone;
exports.brFormattedPhoneToPhone = exports.clFormattedPhoneToPhone;
